import jwtDecode from 'jwt-decode'
import { verify, sign } from 'jsonwebtoken'
import { bffService } from './axios'

const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false
  }
  try {
    const decoded = jwtDecode(accessToken)
    const currentTime = Date.now() / 1000
    return decoded.exp > currentTime
  } catch (error) {
    return false
  }
}

//  const handleTokenExpired = (exp) => {
//   let expiredTimer;

//   window.clearTimeout(expiredTimer);
//   const currentTime = Date.now();
//   const timeLeft = exp * 1000 - currentTime;
//   console.log(timeLeft);
//   expiredTimer = window.setTimeout(() => {
//     console.log('expired');
//   }, timeLeft);
// };

const setSession = (accessToken, refreshToken) => {
  if (accessToken) {
    localStorage.setItem('accessToken', accessToken)
    if (refreshToken) {
      localStorage.setItem('refreshToken', refreshToken)
    }
    bffService.defaults.headers.common.Authorization = `Bearer ${accessToken}`
    // This function below will handle when token is expired
    // const { exp } = jwtDecode(accessToken);
    // handleTokenExpired(exp);
  } else {
    localStorage.removeItem('accessToken')
    localStorage.removeItem('refreshToken')
    delete bffService.defaults.headers.common.Authorization
  }
}

/**
 * Refresh access token using refresh token
 * @param {string} refreshToken - The refresh token to use
 * @returns {Promise<{access_token: string, refresh_token: string}>}
 */
const refreshAccessToken = async (refreshToken) => {
  if (!refreshToken) {
    throw new Error('Refresh token is required')
  }

  try {
    const response = await bffService.post('/users/refresh', {
      refresh_token: refreshToken,
    })

    const { access_token, refresh_token } = response.data

    if (!access_token) {
      throw new Error('Failed to refresh token: No access token in response')
    }

    // Update session with new tokens
    setSession(access_token, refresh_token || refreshToken)

    return {
      access_token,
      refresh_token: refresh_token || refreshToken,
    }
  } catch (error) {
    // Clear session on refresh failure
    setSession(null, null)
    throw error
  }
}

export { verify, sign, isValidToken, setSession, refreshAccessToken }
